import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, UrlTree } from "@angular/router";
import { STEP_ROUTE_MAP } from "@zp-config/step-route-map.config";
import { StateService } from "@zp-services/state.service";

@Injectable({ providedIn: "root" })
export class WizardStepGuard implements CanActivate {
  private readonly stepOrder = Object.keys(STEP_ROUTE_MAP);

  constructor(
    private stateService: StateService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot): boolean | UrlTree {
    const stepId = route.data?.["stepId"];
    if (typeof stepId !== "string") {
      console.warn("[WizardStepGuard] stepId ontbreekt in route data");
      return true;
    }

    if (stepId === this.stepOrder[0]) {
      const currentAnswers = this.stateService.getAnswers();
      if (Object.keys(currentAnswers).length > 0) {
        this.stateService.clearAnswers();
        console.log(
          `[WizardStepGuard] Lokale opslag gewist voor nieuwe wizard sessie op ${stepId}.`
        );
      }
    }

    if (stepId === "step2") {
      return true;
    }

    const stepIndex = this.stepOrder.indexOf(stepId);

    if (stepIndex === -1) {
      console.warn(`[WizardStepGuard] Step '${stepId}' not found in step order. Allowing access.`);
      return true;
    }

    if (stepIndex === 0) {
      return true;
    }

    const previousStepId = this.stepOrder[stepIndex - 1];
    const previousAnswer = this.stateService.getAnswer(previousStepId);

    const isAnswered =
      previousAnswer &&
      Object.values(previousAnswer).some((val) => val !== null && val !== undefined && val !== "");

    if (!isAnswered) {
      const fallbackRoute = STEP_ROUTE_MAP[previousStepId];
      if (!fallbackRoute) {
        console.error(
          `[WizardStepGuard] Geen route gevonden voor previousStepId: ${previousStepId}`
        );
        return this.router.createUrlTree(["/keuzewizard"]);
      }
      return this.router.createUrlTree(["/keuzewizard", fallbackRoute]);
    }

    return true;
  }
}
